export enum LOCAL_STORAGE_KEYS {
    initSession = "init_session",
    session = "session",
    redirectUri = "redirectUri"
}

export type LSKey = LOCAL_STORAGE_KEYS